import React from 'react';

import SignupForm from '../components/SignupForm';
import { SignupV2 } from '../components/SignupV2';

const Signup: React.FC = () => <SignupV2 />;

export default Signup;
